export enum BadgeType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  DANGER = 'danger',
  WARNING = 'warning',
  INFO = 'info',
  LIGHT = 'light',
  DARK = 'dark',
  LAB = 'lab',
  NEW = 'new',
  READY = 'ready',
  TEMPORARY = 'temporary',
  PERMANENT = 'permanent',
}
